import { Box } from "@mui/material";
import Panel from "../components/Panel";
import ListadoCarriles from "../pages/carriles/ListadoCarriles";
import ConsultaTagPanel from "../pages/tags/ConsultaTagPanel";

export default function Home() {
    return (
        <>
            <Panel sx={{ mt: 2 }}>
                <ConsultaTagPanel />
            </Panel>
            <Box sx={{ mt: 2 }}>
                <ListadoCarriles />
            </Box>
        </>
    );
}